<template>
    <div class="category-config-wrap">
        <me-collapes @collapesCb="collapesCb" :treeTitle="title">
            <div class="left_points">
                <div class="title-wrap" v-if="title">
                    <span class="split-line"></span>
                    <img
                        class="byq_icon"
                        src="../../../assets/image/leaderpage/byqicon.png"
                    />
                    {{ title }}
                </div>
                <el-scrollbar style="height: calc(100% - 60px)">
                    <div
                        class="left_bom"
                        v-show="customers && customers.length"
                    >
                        <div
                            v-for="item in customers"
                            :key="item.elec_customer_id"
                            @click="toggleTab(item)"
                            :class="[
                                selectElec_customer_id == item.elec_customer_id
                                    ? 'left_bom_ke left_bom_ke_selected'
                                    : 'left_bom_ke'
                            ]"
                        >
                            <div style="width: 1.5rem">
                                <img
                                    style="width: 0.9rem;height: auto"
                                    src="../../../assets/image/leaderpage/byqicon.png"
                                />
                            </div>
                            <div style="flex:1">{{ item.cust_name }}</div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </me-collapes>
        <div style="width:calc(100% - 13rem)">
            <div class="formula-department-container">
                <div style="height: 750px;">
                    <div>
                        <!-- <el-button size="small"
                                :class="[selectTree_unit_type_id == item.tree_unit_type_id ? 'choose_btn': 'leader-common-button']"
                                v-for="item in treeUnitList"
                            :key="item.tree_unit_type_id"
                                @click="reloadPoints(item)">{{item.type_name}}</el-button> -->

                        <el-form class="leader-style-form">
                            <el-select
                                v-model="selectTree_unit_type_id"
                                @change="reloadPoints"
                            >
                                <el-option
                                    v-for="item in treeUnitList"
                                    :key="item.tree_unit_type_id"
                                    :label="item.type_name"
                                    :value="item.tree_unit_type_id"
                                >
                                </el-option>
                            </el-select>
                        </el-form>
                    </div>
                    <div class="tree-wrap">
                        <me-tree
                            ref="myTree"
                            :treeData="data"
                            :treeLoading="treeLoading"
                            :treeToolBar="true"
                            :defaultProps="defaultUnitProps"
                            :defaultExpandedKeys="defaultCheckKeys"
                            :nodeKey="'tree_unit_id'"
                            :defaultExpandAll="false"
                            :showIcon="true"
                            :showIconKey="'node_expression'"
                            :showSearch="false"
                            :showStretch="false"
                            @handleTreeNodeClick="handleTreeNodeClick"
                            @handleAddTreeNode="handleAddTreeNode"
                            @handleEditTreeNode="handleEditTreeNode"
                            @handleDelTreeNode="handleDelTreeNode"
                        ></me-tree>
                    </div>
                </div>
                <div
                    class="leader-tab power-tab right_container border-left"
                    :style="{ width: width }"
                >
                    <div class="point-tree">
                        <me-tree
                            ref="myPointTree"
                            :treeData="pointData"
                            :treeToolBar="false"
                            :defaultProps="defaultProps"
                            :defaultExpandedKeys="defaultPointCheckKeys"
                            :nodeKey="'point_id'"
                            :defaultExpandAll="false"
                            :showStretch="false"
                            @handleTreeNodeClick="handlePointNodeClick"
                        ></me-tree>
                    </div>
                    <!-- <el-scrollbar
                        style="width: calc(100% - 300px);  height: calc(100% - 60px)"
                    > -->
                    <div class="caculate-wrap">
                        <div class="textWrapper">
                            <div
                                v-for="(item, index) in expressionList"
                                :key="index"
                                class="point_date"
                            >
                                <el-radio
                                    v-model="curUnitExpressionId"
                                    :label="item.unit_expression_id"
                                    @change="changeDateRadio()"
                                >{{ "" }}
                                </el-radio
                                >
                                <el-date-picker
                                    v-model="item.start_time"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH"
                                    placeholder="开始日期"
                                >
                                </el-date-picker>
                                <el-date-picker
                                    v-model="item.end_time"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH"
                                    style="margin-left: 10px;"
                                >
                                </el-date-picker>
                                <el-button
                                    class="leader-common-button"
                                    style="margin-left: 10px !important;background-color: #ff6637;border-color: #ff6637;color: #fff"
                                    size="small"
                                    @click="doAddDate()"
                                    v-if="index == expressionList.length - 1"
                                >+
                                </el-button
                                >
                                <el-button
                                    class="leader-common-button"
                                    style="margin-left: 10px !important;background-color: #ff6637;border-color: #ff6637;color: #fff"
                                    size="small"
                                    @click="doMinusDate()"
                                    v-if="
                                        index > 0 &&
                                            index == expressionList.length - 1
                                    "
                                >-
                                </el-button
                                >
                            </div>
                            <div class="text-wrap">
                                <div v-for="(item, index) in nodelist" :key="index" @mouseover="curHoverItem=item"
                                        @mouseout="curHoverItem=null"
                                        :class="[item.point_name ? (curPoint && curPoint.id == item.id?'text-div border-check':'text-div border-uncheck') : 'text-div border-unwrite']">
                                    <div :class="[item.type=='a' ? 'text_single single_btn': 'text_single']"
                                            @click="curPoint = item">{{item.point_name}}
                                    </div>

                                    <i :class="[curHoverItem==item || (curPoint && curPoint.id == item.id) ? 'el-icon-plus doicon doiconmargin' : 'el-icon-plus doicon doiconmargin icon_hidden']"
                                        @click="changelist(0, item, index)"></i>
                                    <i :class="[curHoverItem==item || (curPoint && curPoint.id == item.id) ? 'el-icon-close doicon' : 'el-icon-plus doicon icon_hidden']"
                                        @click="changelist(1, item, index)"></i>
                                </div>
                                <div @click="changelist(2, item)" class="plus_btn">
                                    <i class="el-icon-plus"></i>
                                </div>
                            </div>
                            <div class="express-btn">
                                <div
                                    class="express-item"
                                    v-for="item in expreeBtns"
                                    :key="item + 'i'"
                                    @click="clickCaculateBtn(item)"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                        <div class="btn-wrap">
                            <div class="btn-inner-wrap">
                                <div class="btn-save" @click="saveExpress">
                                    保存
                                </div>
                                <div
                                    class="btn-clear"
                                    @click="resetExpress"
                                >
                                    清除
                                </div> 
                            </div>
                        </div>
                    </div>
                    <!-- </el-scrollbar> -->
                </div>
                <unit-dialog
                    :dialogVisible.sync="unitVisible"
                    :pUnitId="pUnitId"
                    :treeUnitId="treeUnitId"
                    :treeUnitType="selectTree_unit_type_id"
                    :title="title"
                    :unitName="unitName"
                    :seq="seq"
                    :pointsType="selectTree_unit_type_id"
                    :point_class_id="selectTree && selectTree.point_class_id"
                    @closeCb="closeUnitTree"
                ></unit-dialog>
            </div>
        </div>
    </div>
</template>
<script>
    import * as api from "@/http/api.js";
    import Tree from "@/comon/components/tree.vue";
    import Collapes from "@/comon/components/collapse-block.vue";
    import UnitDialog from "./components/unit-dialog.vue";
    import moment from "moment";

    export default {
        components: {
            "me-tree": Tree,
            "me-collapes": Collapes,
            "unit-dialog": UnitDialog
        },
        data() {
            return {
                defaultProps: {
                    children: "childList",
                    label: "point_name"
                },
                defaultUnitProps: {
                    children: "childList",
                    label: "tree_unit_name"
                },
                checkStrictly: true,
                title: "用户列表",
                customers: [],
                selectElec_customer_id: "",
                pointClassList: [], //能源列表
                treeUnitList: [], //部门 区域 。。。列表
                selectTree_unit_type_id: "", //当前选中的是部门还是区域还是其他啥
                data: [], //左侧树相关的
                defaultCheckKeys: [], //左侧树相关的
                selectTree: {}, //左侧树相关的
                pointData: [], //中间的树
                defaultPointCheckKeys: [], //中间的树
                expreeBtns: [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    ".",
                    "/",
                    "(",
                    ")",
                    "*",
                    "+",
                    "-"
                ],
                unitVisible: false,
                pUnitId: "",
                treeUnitId: "",
                unitName: "",
                seq: "",
                nodelist: [],
                curHoverItem: null,
                curPoint: null,
                expressionList: [],
                oldUnitExpressionId: "",
                curUnitExpressionId: "",
                loading: null
            };
        },
        async created() {
            this.doLoading();
            this.getCommonPointClassList();
            await this.getTreeCustomerList(); //获取用户列表
            await this.getTreeUnitTypeTypeList(); //根据用户id获取是部门还是区域
            await this.getTreeUnitList(); //根据用户id + 部门/区域 获取左侧树
            await this.getPointList(); //根据用户id + 左侧树选中的节点 获取中间的树
            await this.getTreeUnitById();
            this.loading.close();
        },
        mounted() {
        },
        methods: {
            async toggleTab(item) {
                this.doLoading();
                this.selectElec_customer_id = item.elec_customer_id;
                this.selectTree = {};
                this.addNewOne();
                await this.getTreeUnitTypeTypeList(); //根据用户id获取是部门还是区域
                await this.getTreeUnitList(); //根据用户id + 部门/区域 获取左侧树
                await this.getPointList(); //根据用户id + 左侧树选中的节点 获取中间的树
                await this.getTreeUnitById();
                this.loading.close();
            },
            async reloadPoints() {
                this.doLoading();
                this.selectTree = {};
                this.data = [];
                await this.getTreeUnitList();
                await this.getPointList();
                await this.getTreeUnitById();
                this.loading.close();
            },
            //获取用户列表
            async getTreeCustomerList() {
                await api.getTreeCustomerList().then(res => {
                    if (res && res.error_code === "0") {
                        this.selectElec_customer_id =
                            res.bus_json && res.bus_json.length
                                ? res.bus_json[0].elec_customer_id
                                : "";
                        this.customers = res.bus_json;
                    }
                });
            },
            //获取左侧树上面的部门/区域列表
            async getTreeUnitTypeTypeList() {
                this.treeUnitList=[];
                if (!this.selectElec_customer_id) return;
                await api
                    .getTreeUnitTypeTypeList({
                        elec_customer_id: this.selectElec_customer_id
                    })
                    .then(res => {
                        if (res && res.error_code === "0") {
                            this.treeUnitList = res.bus_json;
                            this.selectTree_unit_type_id =
                                res.bus_json && res.bus_json.length
                                    ? res.bus_json[0].tree_unit_type_id
                                    : "";
                        }
                        if (this.treeUnitList.length===0) {
                            this.$message({
                                message: "此用户下没有分类统计字典！",
                                type: "warning"
                            });
                            return;
                        }
                    });
            },
            // 获取左侧部门树
            async getTreeUnitList() {
                this.data=[];
                if (!this.selectTree_unit_type_id) return;
                await api
                    .getTreeUnitList({
                        tree_unit_type_id: this.selectTree_unit_type_id
                    })
                    .then(res => {
                        if (res) {
                            this.data = res.bus_json;
                            this.defaultCheckKeys = [
                                res.bus_json &&
                                res.bus_json[0] &&
                                res.bus_json[0].tree_unit_id
                            ];
                            this.$nextTick(() => {
                                if (this.selectTree.tree_unit_id) {
                                    this.$refs.myTree.$refs.tree.setCurrentKey(
                                        this.selectTree.tree_unit_id
                                    );
                                    this.selectTree = this.$refs.myTree.$refs.tree.getCurrentNode();
                                } else {
                                    //初始化的时候不默认选择任何点
                                    // this.$refs.myTree.$refs.tree.setCurrentKey(
                                    //     this.defaultCheckKeys[0]
                                    // );
                                    // this.selectTree = res.bus_json && res.bus_json[0];
                                }
                            });
                        }
                    });
            },
            /**
             * 获取中间的树
             */
            async getPointList() {
                if (!this.selectTree) return;
                await api
                    .getPointList({
                        elec_customer_id: this.selectElec_customer_id,
                        point_class_id: this.selectTree.point_class_id
                    })
                    .then(res => {
                        if (res) {
                            this.pointData = res.bus_json;
                            let formatData = this.tickMenuIdFilter().filter(
                                res.bus_json
                            );
                            this.defaultPointCheckKeys = [
                                formatData.firstPoint.point_id
                            ];
                        }
                    });
            },
            async getTreeUnitById() {
                if (!this.selectTree || !this.selectTree.tree_unit_id) {
                    this.addNewOne();
                    return;
                }
                await api
                    .getTreeUnitById({
                        tree_unit_id: this.selectTree.tree_unit_id
                    })
                    .then(res => {
                        if (res) {
                            this.expressionList = res.bus_json;
                            if (this.expressionList && this.expressionList.length) {
                                this.curUnitExpressionId = this.oldUnitExpressionId = this.expressionList[0].unit_expression_id;
                                this.expressionList.forEach(item => {
                                    this.$set(item, "nodelist", []);
                                    item.nodelist = [];
                                    if (item.node_expression_show) {
                                        const showArr = item.node_expression_show.split(
                                            ","
                                        );
                                        const idsArr = item.node_expression.split(
                                            ","
                                        );
                                        showArr &&
                                        showArr.forEach((k, i) => {
                                            if (k) {
                                                const type = k.charAt(
                                                    k.length - 1
                                                );
                                                if (type == "$") {
                                                    item.nodelist.push({
                                                        id: this.random(
                                                            1000000000,
                                                            1
                                                        ),
                                                        point_id: idsArr[
                                                            i
                                                            ].substring(
                                                            0,
                                                            idsArr[i].length - 1
                                                        ),
                                                        point_name: k.substring(
                                                            0,
                                                            k.length - 1
                                                        ),
                                                        type: "t"
                                                    });
                                                } else if (type == "&") {
                                                    item.nodelist.push({
                                                        id: this.random(
                                                            1000000000,
                                                            1
                                                        ),
                                                        point_id: "",
                                                        point_name: k.substring(
                                                            0,
                                                            k.length - 1
                                                        ),
                                                        type: "a"
                                                    });
                                                }
                                            }
                                        });
                                    }
                                });
                                this.nodelist =
                                    this.expressionList &&
                                    this.expressionList.length
                                        ? this.expressionList[0].nodelist
                                        : [];
                                this.clearCurrent();
                            } else {
                                this.addNewOne();
                            }
                        }
                    });
            },
            addNewOne() {
                const unit_expression_id = new Date().getTime();
                this.expressionList = [];
                this.expressionList.push({
                    unit_expression_id: unit_expression_id,
                    start_time: "1999-01-01 07",
                    end_time: "2099-01-01 07",
                    node_expression: "",
                    point_ids: ""
                });
                this.curUnitExpressionId = this.oldUnitExpressionId = unit_expression_id;
                this.nodelist = [];
                this.clearCurrent();
            },
            // 新增修改删除部门成功回调
            async closeUnitTree() {
                this.doLoading();
                this.pUnitId = "";
                this.treeUnitId = "";
                this.unitName = "";
                this.seq = "";
                await this.getTreeUnitList();
                await this.getPointList();
                await this.getTreeUnitById();
                this.loading.close();
            },
            // 添加部门
            handleAddTreeNode(select) {
                if (this.treeUnitList.length===0) {
                    this.$message({
                        message: "请先添加分类统计字典！",
                        type: "warning"
                    });
                    return;
                }
                if (this.selectTree) this.pUnitId = this.selectTree.tree_unit_id;
                else this.pUnitId = "";
                this.treeUnitId = "";
                this.title = "新增";
                this.unitName = "";
                this.seq = "";
                this.unitVisible = true;
            },
            // 修改部门
            handleEditTreeNode(select) {
                this.pUnitId = this.selectTree.tree_unit_id;
                if (!this.pUnitId) {
                    this.$message({
                        message: "请先选择分类！",
                        type: "warning"
                    });
                    return;
                }
                this.pUnitId = this.selectTree.p_tree_unit_id;
                this.treeUnitId = this.selectTree.tree_unit_id;
                this.unitName = this.selectTree.tree_unit_name;
                this.seq = this.selectTree.seq;
                this.title = "修改";
                this.unitVisible = true;
            },
            // 删除部门
            handleDelTreeNode(select) {
                this.pUnitId = this.selectTree.tree_unit_id;
                if (!this.pUnitId) {
                    this.$message({
                        message: "请先选择一条需要删除的数据",
                        type: "info"
                    });
                    return;
                }
                this.$confirm("确定删除此项?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        api.delUnit({
                            tree_unit_id: this.pUnitId
                        }).then(res => {
                            if (res && res.error_code == 0) {
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                this.selectTree = {};
                                this.closeUnitTree();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            // 点击部门树节点
            async handleTreeNodeClick(select) {
                this.selectTree = select;
                this.nodelist = [];
                await this.getPointList();
                await this.getTreeUnitById();
            },
            doLoading() {
                this.loading = this.$loading({
                    lock: true,
                    text: "加载中",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
            },
            /**
             * 监听树结构收起展开
             */
            collapesCb(collapes) {
                this.width = collapes ? "calc(100% - 370px)" : "calc(100% - 56px)";
            },
            // 计算器按钮点击回调
            clickCaculateBtn(caculateBtn) {
                const select = { point_name: caculateBtn };
                this.savePointName(select, "a");
            },
            handlePointNodeClick(select) {
                if (select.is_collector == 1) {
                    this.savePointName(select, "t");
                } else {
                    this.$message({
                        message: "当前采集点未安装采集器",
                        type: "warning"
                    });
                }
            },
            changelist(type, item, index) {
                let ran_id = this.random(1000000000, 1);
                console.log(this.selectTree.tree_unit_id);
                if (!this.selectTree.tree_unit_id) {
                    this.$message({
                        message: "请先选择分类",
                        type: "warning"
                    });
                }

                if (type == 2) {
                    //追加
                    const point = {
                        id: ran_id,
                        point_id: "",
                        point_name: "",
                        type: 0
                    };
                    this.nodelist.push(point);
                    this.$nextTick(() => {
                        this.curPoint = point;
                    });
                } else if (type == 0) {
                    //插入
                    const arr1 = this.nodelist.slice(0, index);
                    const arr2 = this.nodelist.slice(index, this.nodelist.length);
                    const point = {
                        id: ran_id,
                        point_id: "",
                        point_name: "",
                        type: 0
                    };
                    arr1.push(point);
                    this.nodelist = [...arr1, ...arr2];
                    this.$nextTick(() => {
                        this.curPoint = point;
                    });
                } else if (type == 1) {
                    //删除
                    const arr1 = this.nodelist.slice(0, index);
                    const arr2 = this.nodelist.slice(
                        index + 1,
                        this.nodelist.length
                    );
                    this.nodelist = [...arr1, ...arr2];
                    this.$nextTick(() => {
                        if (this.curPoint.id == item.id) {
                            this.curPoint = null;
                        }
                    });
                }
            },
            savePointName(select, type) {
                //type =='a' 按键   type=='t'树
                if (!this.curPoint) {
                    this.$message({
                        message: "请先选择一个节点",
                        type: "warning"
                    });
                }
                this.nodelist.forEach(item => {
                    if (item.id == this.curPoint.id) {
                        if (type == "a") {
                            if (this.curPoint && this.curPoint.type == "a")
                                item.point_name += select.point_name;
                            else item.point_name = select.point_name;
                        } else {
                            item.point_id = select.point_id;
                            item.point_name = select.point_name;
                        }
                        item.type = type;
                    }
                });
            },
            clearCurrent() {
                this.node_expression = "";
                this.point_ids = "";
                this.curPoint = null;
            },
            random(min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            },
            // 清除公式
            resetExpress() {
                this.$confirm("确定清除此公式?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.nodelist = [];
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            saveExpress() {
                if (!this.selectTree) {
                    this.$message({
                        message: "请先选择一个分类",
                        type: "warning"
                    });
                    return;
                }
                //先验证有无未填写的内容
                const unWrite = this.nodelist.filter(item => !item.point_name);
                if (unWrite && unWrite.length > 0) return;
                //保存上一次输入的东西
                this.saveLastData();
                this.genSaveParams();
                const params = {
                    tree_unit_id: this.selectTree.tree_unit_id,
                    expressionList: this.expressionList
                };
                api.saveExpress(params).then(res => {
                    if (res && res.error_code == 0) {
                        this.$message({
                            message: res.error_msg,
                            type: "success"
                        });
                        this.expressionList = [];
                        this.nodelist = [];
                        this.closeUnitTree();
                    }
                });
            },
            genSaveParams() {
                this.expressionList.forEach(item => {
                    if (!item.start_time || !item.end_time) {
                        this.$message({
                            message: "请选择时间段",
                            type: "warning"
                        });
                        return;
                    }else {
                        item.start_time = moment(item.start_time).format(
                            "YYYY-MM-DD HH:mm:ss"
                        );
                        item.end_time = moment(item.end_time).format(
                            "YYYY-MM-DD HH:mm:ss"
                        );
                        item.point_ids = "";
                        item.node_expression = "";
                        item.nodelist &&
                        item.nodelist.forEach(data => {
                            if (data.type == "t") {
                                item.point_ids += data.point_id + ",";
                                item.node_expression += data.point_id + "$,";
                            } else {
                                item.node_expression += data.point_name + "&,";
                            }
                        });
                    }
                  
                });
            },
            changeDateRadio() {
                //保存上一次输入的东西
                this.saveLastData();
                //回显
                this.expressionList.forEach(item => {
                    if (item.unit_expression_id == this.curUnitExpressionId) {
                        this.nodelist = item.nodelist || [];
                    }
                });
            },
            saveLastData() {
                this.expressionList.forEach(item => {
                    if (item.unit_expression_id == this.oldUnitExpressionId) {
                        item.nodelist = this.nodelist;
                    }
                });
                this.oldUnitExpressionId = this.curUnitExpressionId;
            },
            doAddDate() {
                this.expressionList.push({
                    unit_expression_id: new Date().getTime(),
                    start_time: "",
                    end_time: "",
                    node_expression: "",
                    point_ids: ""
                });
            },
            doMinusDate() {
                this.expressionList.pop();
                this.curUnitExpressionId = this.oldUnitExpressionId = this.expressionList[0].unit_expression_id;
                this.nodelist = this.expressionList[0].nodelist;
            },
            getCommonPointClassList() {
                api.getCommonPointClassList().then(res => {
                    if (res && res.error_code === "0") {
                        this.pointClassList = res.bus_json;
                    }
                });
            },
            /**
             * 格式化tree disabled状态；
             */
            tickMenuIdFilter: () => {
                let resultArr = new Array();
                let firstPoint = new Object();
                let getTickMenuId = function(obj) {
                    if (
                        undefined === obj ||
                        null === obj ||
                        !(obj instanceof Object)
                    ) {
                        return;
                    }
                    if (obj.state === "1") {
                        //实采集点
                        obj.disabled = true;
                        resultArr.push(obj.point_id);
                    } else if (obj.state === "0") {
                        //虚点
                        if (!firstPoint.point_id) {
                            firstPoint = obj;
                        }
                    }

                    if (null != obj.childList && obj.childList instanceof Array) {
                        for (let child of obj.childList) {
                            getTickMenuId(child);
                        }
                    }
                };

                return {
                    filter: function(arr) {
                        if (!(arr instanceof Array)) {
                            return false;
                        }
                        resultArr = new Array();
                        firstPoint = new Object();
                        for (let rootMenu of arr) {
                            getTickMenuId(rootMenu);
                        }
                        return { tree: resultArr, firstPoint: firstPoint };
                    }
                };
            },
            doLoading() {
                this.loading = this.$loading({
                    lock: true,
                    text: "加载中",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
            }
        },
        computed: {}
    };
</script>
<style lang="scss">
    .category-config-wrap {
        padding: 20px;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        .collapes-block-container {
            margin: 0 0.8rem !important;
            width: 12.2rem !important;
        }
        .left_points {
            height: 100%;
            .title-wrap {
                text-align: left;
                font-size: 16px;
                width: 100%;
                height: 50px;
                line-height: 50px;
                padding-left: 10px;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                color: #fff;
                justify-content: left;
                border-bottom: 1px solid #dedede;
                margin-bottom: 10px;
                .title {
                    padding-right: 10px;
                }
                .split-line {
                    display: inline-block;
                    background: #56fcff;
                    width: 4px;
                    height: 14px;
                    border-radius: 2px;
                    margin-right: 10px;
                }
            }
            .left_bom {
                border-top: 1px solid #56fcff;
                border-left: 1px solid #56fcff;
                border-right: 1px solid #56fcff;
            }
            .left_bom_ke {
                width: 100%;
                height: 2rem;
                border-bottom: 1px solid #56fcff;
                display: flex;
                align-items: center;
                flex-flow: wrap;
                color: #fff;
                padding: 0 0.8rem;
                box-sizing: border-box;
                cursor: pointer;
            }
            .left_bom_ke_selected {
                background-color: #277ea3;
            }
        }
        .formula-department-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            .active-table {
                background: #ff7455 !important;
                color: #fff !important;
                border-color: #ff7455 !important;
            }
            .tree-wrap {
                height: calc(100% - 10px);
                padding-top: 0.3rem;
                box-sizing: border-box;
            }
            .right_container {
                height: 100%;
                width: calc(100% - 280px);
                display: inline-flex;
                justify-content: space-between;
                .caculate-wrap {
                    width: 100%;
                    height: 100%;
                //    overflow-y: auto;
                .textWrapper {
                    width: 100%; height: calc(100% - 5rem); overflow-y: auto;
                }
                    .text-wrap {
                        width: 100%;
                        min-height: 7rem;
                        border: 1px solid #56fcff;
                        border-radius: 6px;
                        color: #56fcff;
                        font-size: 1.2rem;
                        line-height: 1em;
                        padding: 0.6rem;
                        box-sizing: border-box;
                        display: flex;
                        flex-flow: row wrap;
                        cursor: pointer;
                        margin-top: 8px;
                        .text-div {
                            padding: 0 0.5rem 0 0;
                            border-radius: 0.2rem;
                            display: flex;
                            align-items: center;
                            height: 2rem;
                            color: #fff;
                            margin-right: 0.6rem;
                            margin-bottom: 0.8rem;
                            // div {
                            //     cursor: pointer;
                            //     margin-left: 5px;
                            //     color: #fff;
                            //     display: inline-block;
                            // }
                            .doicon {
                                font-size: 0.8rem;
                                //margin-left: 0.5rem;
                                border-radius: 50%;
                                // padding: 0.1rem;
                                // width: 0.8rem;
                                &:hover {
                                    background-color: rgb(165, 162, 162);
                                }
                            }
                            .doiconmargin {
                                margin-right: 0.5rem;
                            }
                            .icon_hidden {
                                visibility: hidden;
                            }
                        }
                        .text_single {
                            margin-right: 0.3rem;
                            padding: 0.4rem;
                            font-size: 0.9rem;
                            width: 100%;
                            height: 100%;
                            line-height: 2rem;
                            min-width: 3rem;
                        }
                        .single_btn {
                            color: #ff0000;
                        }
                        .plus_btn {
                            height: 0.7rem;
                            background-color: #e9575a;
                            border: 1px solid #e9575a;
                            color: #fff;
                            padding: 0.6rem;
                            border-radius: 0.2rem;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                        }
                        .border-uncheck {
                            border: 1px solid #fff;
                        }
                        .border-check {
                            border: 1px solid #e9575a;
                        }
                        .border-unwrite {
                            border: 1px solid red;
                        }
                    }
                    .express-btn {
                        width: 36rem;
                        margin-top: 20px;
                        display: flex;
                        flex-wrap: wrap;
                        margin: 0 auto;
                        margin-top: 2rem;
                        .express-item {
                            margin-right: 1.4rem;
                            margin-bottom: 1.6rem;
                            width: 4rem;
                            height: 4rem;
                            background: linear-gradient(
                                    -12deg,
                                    #171533,
                                    #063b7b,
                                    #1e1837
                            );
                            border: 1px solid #56fcff;
                            border-radius: 50%;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 1.5rem;
                            color: #00e1d4;
                            cursor: pointer;
                        }
                    }
                    .btn-wrap {
                        width: 36rem;
                        margin: 0 auto;
                        margin-top: 1rem;
                        .btn-inner-wrap {
                            display: inline-flex;
                            margin-left: 2rem;
                        }
                        .btn-clear,
                        .btn-save {
                            width: 8.5rem;
                            height: 2.2rem;
                            line-height: 2.2rem;
                            text-align: center;
                            font-size: 1rem;
                            color: #fff;
                            border-radius: 0.3rem;
                            cursor: pointer;
                        }
                        .btn-clear {
                            background: #8e9eab;
                            border: 1px solid #3d3d3d;
                        } 
                        .btn-save {
                            margin-right: 3rem;
                            background: linear-gradient(-12deg, #073775, #5c0991);
                            border: 1px solid #3d3d3d;
                        }
                    }
                    .point_date {
                        display: inline-flex;
                        align-items: center;
                        margin-top: 5px;
                        width: 100%;
                    }
                }
            }
            .border-left {
                border-left: 1px solid #56fcff;
            }
            .point-tree {
                height: 100%;
                width: 340px;
                margin-left: 5px;
            }
            .choose_btn {
                border: 1px solid #e9575a;
                color: #fff;
                font-size: 14px;
                background: none;
                border-radius: 8px;
                background-color: #e9575a;
                color: #fff;
            }
        }
    }
</style>
